import { put, call } from 'redux-saga/effects';
import { getVouchers } from '../../repositories/VouchersRepository';
import { ApiConstants, OverlaysConstants } from '../../constants/actions';
import { UnauthorizedErrorName } from '../../constants/errorName';
import { HandleUnauthorizedErrorAndLogout } from '../../helpers/AuthorizeHelper';

export function* loadVouchers() {
  try {
    const voucherResponse = yield call(getVouchers);
    yield put({
      type: `${ApiConstants.LOAD_VOUCHERS}_SUCCESS`,
      payload: voucherResponse
    });
  } catch (ex) {
    // change the loading status
    yield put({
      type: `${ApiConstants.LOAD_VOUCHERS}_FAILURE`,
      payload: ex
    });
    if (ex.name === UnauthorizedErrorName) {
      yield call(HandleUnauthorizedErrorAndLogout);
    } else {
      // display the error message
      yield put({
        type: `${OverlaysConstants.SHOW_ERROR_POPUP}`,
        closable: false
      });
    }
  }
}

export default { loadVouchers };
